export default __webpack_public_path__ + "static/media/Tasset of Fearless Souls.73f729d1.jpg";